// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"33024568101558e02112","532":"920cbc91426acfa809ec","691":"b4624218e6adfcf8677a"}[chunkId] + ".js";
};